import React from 'react'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
}))

const ChipNew = () => {
  const classes = useStyles()
  return <Chip className={classes.root} label="NEW" size="small" />
}

export default ChipNew
